import React from 'react';
import BlackLogo from "./BlackLogo";
import WhiteLogo from "./WhiteLogo";

const IETIcon = (props) => {
    return props.theme === 'light' ? <BlackLogo /> : <WhiteLogo />;
};

export default IETIcon;
